import "../../../grjs7/dist/gr_reco7";
import { init, getImpressionId, hashString } from "../../init";
import template from "./html/template.html";

const PUBLISHER_ID = "1003434";
const PLACEMENT_SELECTORS = [".recirculation"];

// can be beforeend, afterend, beforebegin, afterbegin
// https://developer.mozilla.org/en-US/docs/Web/API/Element/insertAdjacentHTML
const PLACEMENT_TARGET = "beforebegin";

const NUMBER_LIMIT_FOR_RECOMMENDABLE_ITEMS = 16;
const PLACEMENT_UNIQUE_ID = "GR_PLACEMENT_289123";
const SCENARIO_ID = "ECREC";
const PROPERTY_LIST = ["url", "itemid", "imageUrl", "ogtitle", "description", "category", "author"];
const TEMPLATE = template;
const GROUP_ID = "ARTICLES_1";
const ELEMENT_TO_HIDE = ".recirculation";

const UTM_PARAM = "utm_content=purewow_editorial";
const UTM_PARAM_VALUE = "utm_";
const SCANNED_LINK_ATTRIBUTE = "data-tbl-utm-original-link";
const ARTICLE_CARD_SELECTOR = ".article-card";
const VIEW_MORE_SELECTOR = ".see-more-button";

function isRecommendationEnabled() {
  // const currentPathName = window.location.pathname;
  const hostName = window.location.hostname;
  // return !currentPathName.startsWith("/news") && currentPathName !== "/" && currentPathName !== "";
  return hostName === "staging.purewow.net";
}

function customScriptAfter(items) {
  const element = document.querySelector(".recommendation-box-container.purewow");
  if (!element || element === null) return;
  
  element.addEventListener("click", function (e) {
    if (e.target.classList.contains("see-more-button")) {
      document.querySelector(".article-card.big-card").parentElement.classList.add("show-more-items");
    }
    document.querySelector(".see-more-button").style.display = "none";
  });
}

/**
    @param {string} containerSelector - The selector of the container where the recommendation box will be placed
    @param {string} targetPosition - The position where the recommendation box will be placed
    @param {string} placementId - The id of the placement that should be unique
    @param {string} scenarioId - The id of the scenario for recommendation LOGIC
    @param {string[]} resultNames - Parameter list for RECO to give values for
    @param {number} numberLimit - How many items should be recommended by reco
    @param {string} template - The template of the recommendation box
    @param {number} groupSize - The size of the group  TODO: can be calculated from the length of the PLACEMENT_DATA
    @param {number} groupSeq - The sequence of the group  TODO can be calculated from the index of the PLACEMENT_DATA
    @param {string} groupId - The id of the group that it's useful for grouping the PLACEMENT_DATA items
    @param {string} elementToHide - The element that should be hidden if the recommendation box is NOT empty
*/

const PLACEMENT_1 = [
  PLACEMENT_SELECTORS[0],
  PLACEMENT_TARGET,
  PLACEMENT_UNIQUE_ID,
  SCENARIO_ID,
  PROPERTY_LIST,
  NUMBER_LIMIT_FOR_RECOMMENDABLE_ITEMS,
  TEMPLATE,
  1,
  1,
  GROUP_ID,
  ELEMENT_TO_HIDE,
];

const PLACEMENT_DATA = [PLACEMENT_1];

function updateOriginalArticleCardLinks(wrapper) {
  let linkElements = wrapper.querySelectorAll(ARTICLE_CARD_SELECTOR + ":not([" + SCANNED_LINK_ATTRIBUTE + "])");

  Array.from(linkElements).forEach((element) => {
    let originalHref = element.getAttribute("href");
    if (!originalHref || originalHref === null) return;
    const hasSearch = originalHref.indexOf("?") !== -1;

    if (originalHref && originalHref.indexOf(UTM_PARAM_VALUE) === -1) {
      const replacementLink = hasSearch ? originalHref + "&" + UTM_PARAM : originalHref + "?" + UTM_PARAM;
      element.setAttribute("href", replacementLink);
      element.setAttribute(SCANNED_LINK_ATTRIBUTE, true);
    }
  });
}

function disabledRecommendationAfterScript() {
  try {
    const wrapper = document.querySelector(PLACEMENT_SELECTORS[0]);

    if (wrapper) {
      updateOriginalArticleCardLinks(wrapper);

      const viewMoreElement = wrapper.querySelector(VIEW_MORE_SELECTOR);

      if (viewMoreElement) {
        viewMoreElement.addEventListener("click", function () {
          setTimeout(() => {
            updateOriginalArticleCardLinks(wrapper);
          }, 0);
        });
      }
    }
  } catch (error) {
    console.log("Ecrec content recirculation - Error while updating original links in recirculation", error);
  }
}

function locationStringOverride() {
  const canonicalLink = document.querySelector('link[rel="canonical"]');
  if (canonicalLink !== null) {
    const url = new URL(canonicalLink.href);
    if (url.hostname === "qa.purewow.net" || url.hostname === "staging.purewow.com") {
      url.hostname = "www.purewow.com";
    }
    return url.hostname + url.pathname;
  } else {
    return window.location.hostname === "qa.purewow.net" || window.location.hostname === "staging.purewow.com"
      ? "www.purewow.com" + window.location.pathname
      : window.location.hostname + window.location.pathname;
  }
}

export const overrideGetItemIdFunction = (() => {
  let hash = null;
  const locationString = locationStringOverride();
  return async (prefix) => {
    if (!hash) {
      hash = await hashString(locationString);
    }
    return prefix ? `${prefix}_${hash}_${locationString}` : `${hash}_${locationString}`;
  };
})();

function initCallback() {
  /**   
        @param {function Boolean} isRecommendationEnabled - Function that returns a boolean value whether the recommendation should be enabled or not
        @param {string} PUBLISHER_ID - Prefix for itemIds and value for Advertiser ID
        @param {Array} PLACEMENT_DATA - Recommendation details
        @param {string} initCallback - Function for intialization in case of navigation with SPA
        @param {string} CSS_OVERRIDE - CSS for adjustemnts on Publisher page elements   
        @param {boolean} isInsertCSSReset - whether to insert CSS reset for recommendation box, default is true   
        @param {customCarousel} function - unique full functionality for carousel 
        @param {customScriptAfter} function - customScript at the after recommendation
        @param {customScriptBefore} function - customScript at the beginning of the init function 
        @param {disabledRecommendationAfterScript} function - customScript for disabled recommendation
        @param {overrideGetItemIdFunction} function - script for overriding getItemId
    */
  init(
    isRecommendationEnabled,
    PUBLISHER_ID,
    PLACEMENT_DATA,
    initCallback,
    undefined,
    false,
    undefined,
    customScriptAfter,
    undefined,
    disabledRecommendationAfterScript,
    overrideGetItemIdFunction
  );
}

initCallback();
